<template>
  <div class="animated fadeIn">
	<b-row class="mb-5">
		<b-col>
			<b-form-group
				label="Therapist"
				label-cols-sm="3"
				label-align-sm="right"
				label-for="filterTherapist"
				class="mb-0"
				>
				<b-form-select id="filterTherapist" :options="therapist_opts" v-model="f_therapist"></b-form-select>
			</b-form-group>
		</b-col>
		<b-col>
			<b-form-group
				label="Sort By"
				label-cols-sm="3"
				label-align-sm="right"
				label-for="sortBy"
				class="mb-0"
				>
				<b-form-radio-group
					id="radio-group-1"
					buttons
					v-model="sortBy"
					:options="['Next App', 'Patient Name']"
					name="radio-options"
				></b-form-radio-group>
			</b-form-group>
		</b-col>
		<b-col>
			<b-form-group
				label="Patient"
				label-cols-sm="3"
				label-align-sm="right"
				label-for="filterPatient"
				class="mb-0"
				>
				<b-input-group>
					<b-form-input
					v-model="f_patient_name"
					type="search"
					id="filterPatient"
					placeholder="Type to Search"
					></b-form-input>
					<b-input-group-append>
					<b-button :disabled="!f_patient_name" @click="f_patient_name = ''">Clear</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
		</b-col>

	</b-row>
	Showing {{filtered_cases.length}} of {{therapist_cases.length}} for {{selectedTherapist()}}
	<b-card no-body class="mb-0">
		<b-card-header class="font-weight-bold">
			<b-row>
				<b-col cols="1"> </b-col>
				<b-col cols="2">Patient</b-col>
				<b-col cols="1">Last Visit</b-col>
				<b-col cols="1">Rx Count</b-col>
				<b-col cols="1">Ins Avail</b-col>
				<b-col cols="1">Treated</b-col>
				<b-col cols="1">Sched</b-col>
				<b-col cols="1">Total</b-col>
				<b-col cols="1">Forecast</b-col>
				<b-col class="text-left" cols="1">Next Visit</b-col>
			</b-row>
		</b-card-header>
	</b-card>
	<b-card v-if="filtered_cases.length < 1">
        {{ this.f_therapist ? 'No open cases for '.concat(selectedTherapist()) : 'Please select a therapist' }}
		<!--Please select a Therapist at the top of the page. -->
	</b-card>
	<b-card no-body v-for="(c, i) in filtered_cases" :key="'CASEROW__'+i" class="mb-0 text-dark" :class="bgVariant(c)">
		<b-card-header v-b-toggle="'COLLAPSE__'+i" >
			<b-row>
				<b-col cols="1">
					<i v-if="!validCase(c)" v-b-tooltip.hover title="This case has technical errors and may not be complete" class="fa fa-exclamation text-warning ml-1 mr-1" />
					<i v-if="businessConcerns(c)" class="fa fa-check text-success ml-1 mr-1" v-b-tooltip.hover title="Everything looks good, no immediate attention required" /></i>
					<i v-else class="fa fa-exclamation-triangle text-danger ml-1 mr-1" v-b-tooltip.hover title="Needs Attention" /></i>
				</b-col>

				<b-col cols="2"> {{ c.patient.last_name }}, {{ c.patient.first_name }}</b-col>
				<b-col class="text-left" cols="1">
                  <span v-if="c.last_visit_at">
                    {{c.last_visit_at |formatDate}}
                  </span><span v-else class="text-danger">
                    None
                  </span>
                </b-col>
				<b-col class="text-left" cols="1">{{ c.total_prescribed_visits }}</b-col>
				<b-col class="text-left" cols="1">{{ c.ins_available_visits }}</b-col>
				<b-col class="text-left" cols="1">{{ c.last_visit_app_count }}</b-col>
				<b-col class="text-left" cols="1">{{ c.scheduled_visit_count }}</b-col>
				<b-col class="text-left" cols="1">{{ c.scheduled_visit_count + c.last_visit_app_count }}</b-col>
				<b-col class="text-left" cols="1">{{ c.total_forecast_visits }}</b-col>

				<b-col class="text-left" cols="2">
                  <span v-if="!c.last_visit_at">
                    <b>EVAL:</b>
                  </span><span v-if="c.next_visit_at">
                    {{c.next_visit_at |formatDate}}
                  </span><span v-else class="text-danger">
                    None
                  </span>
                </b-col>
			</b-row>
		</b-card-header>
		<b-form @submit.preventDefault="handleSave" :id="'FORM__'+i">
		<b-collapse :id="'COLLAPSE__'+i" accordion="aaacordion">
			<b-card-text class="m-3">
				<b-row class="mb-3">
					<b-col cols="12">
						<b-button :disabled="!c.lead || saving" type="submit" value="Save" variant="success">{{ saving ? 'Saving...' : 'Save' }}</b-button>
						<input type="hidden" name="lead_id" v-if="c.lead" :value="c.lead.id" />
					</b-col>
				</b-row>
				<b-card-group>
					<b-card v-if="c.patient">
						<b-card-title>Patient Info</b-card-title>
						<b-row>
							<b-col cols="4">Name:</b-col>
							<b-col cols="8">{{ c.patient.last_name}}, {{c.patient.first_name}}</b-col>
						</b-row>
						<b-row>
							<b-col cols="4">Phone:</b-col>
							<b-col cols="8"><a target="_blank" :href="'tel:'+c.patient.phone">{{ c.patient.phone | formatPhone}}</a> <span v-if="c.patient.phone2"> | <a :href="'tel:'+c.patient.phone2">{{c.patient.phone2 | formatPhone}}</a> </span></b-col>
						</b-row>
						<b-row>
							<b-col cols="4">Email:</b-col>
							<b-col cols="8"><a target="_blank" :href="'mailto:'+c.patient.email">{{ c.patient.email }}</a></b-col>
						</b-row>
						<b-row>
							<b-col cols="4">Address:</b-col>
							<b-col cols="8"><a target="_blank" :href="getPatientGoogleMapLink(c)">{{c.patient.address}}<br />{{c.patient.city}}, {{c.patient.state}} {{c.patient.zip}}</a></b-col>
						</b-row>
						<b-row v-if="c.lead">
							<b-col cols="4">Address Note:</b-col>
							<b-col cols="8">{{c.lead.treatment_address_notes}}</b-col>
						</b-row>
						<div v-if="c.doctor">
							<b-card-title class="mt-3">Doctor Info</b-card-title>
							<b-row>
								<b-col cols="4">Name:</b-col>
								<b-col cols="8">{{ c.doctor.last_name }}, {{ c.doctor.first_name }}</b-col>
							</b-row>
							<b-row v-if="c.doctor.specialty">
								<b-col cols="4">Specialty:</b-col>
								<b-col cols="8">{{ c.doctor.specialty }}</a></b-col>
							</b-row>
							<b-row>
								<b-col cols="4">Phone:</b-col>
								<b-col cols="8"><a target="_blank" :href="'tel:'+c.doctor.phone">{{ c.doctor.phone | formatPhone }}</a> <span v-if="c.doctor.cell"> | <a :href="'tel:'+c.doctor.cell">{{c.doctor.cell | formatPhone}}</a> </span></b-col>
							</b-row>
							<b-row v-if="c.doctor.email">
								<b-col cols="4">Email:</b-col>
								<b-col cols="8"><a target="_blank" :href="'mailto:'+c.doctor.email">{{ c.doctor.email }}</a></b-col>
							</b-row>
							<b-row>
								<b-col cols="4">Address:</b-col>
								<b-col cols="8"><a target="_blank" :href="getDoctorGoogleMapLink(c)">{{c.doctor.address}}<br />{{c.doctor.city}}, {{c.doctor.state}} {{c.doctor.zip}}</a></b-col>
							</b-row>
						</div>
						<div>
							<b-card-title class="mt-3">Insurance Info</b-card-title>
							<b-row class="mb-3">
								<b-col cols="4">Payer(s):</b-col>
								<b-col cols="8">{{c.payers}}</b-col>
							</b-row>
							<!-- FOR LATER <b-row>
								<b-col cols="4">Ins 1:</b-col>
								<b-col cols="8">{{c.ins1_id}}</b-col>
							</b-row>
							<b-row v-if="c.ins2_id">
								<b-col cols="4">Ins 2:</b-col>
								<b-col cols="8">{{c.ins2_id}}</b-col>
							</b-row>
							<b-row v-if="c.ins3_id">
								<b-col cols="4">Ins 3:</b-col>
								<b-col cols="8">{{c.ins3_id}}</b-col>
							</b-row>-->
							<b-form-group label="Ins Avail Vists:" label-cols="4">
								<b-input v-if="c.lead" type="number" readonly  :value="c.lead.ins_available_visits" />
								<b-input v-else  readonly  :value="c.ins_available_visits" />
							</b-form-group>
							<b-form-group label="Additional Visits Type: " label-cols="4">
								<b-input type="text" readonly  :value="c.additional_visits_type" />
							</b-form-group>
						</div>
					</b-card>
					<b-card v-if="c.lead">
						<b-card-title>Case: {{ c.case_description}}</b-card-title>
						<b-progress class="mb-3" height="2rem" :max="parseInt(c.total_forecast_visits)">
							<b-progress-bar :value="c.last_visit_app_count">
								Progress: <strong>{{c.last_visit_app_count}} of {{c.total_forecast_visits}}</strong>
							</b-progress-bar>
						</b-progress>
						<b-card v-if="c.status=='On Hold'">
							<b-card-title>On Hold</b-card-title>
							<b-form-group label="Until" label-cols="4">
								<b-form-input disabled type="date" v-model="c.hold_until" />
							</b-form-group>
							<b-form-group label="Reason" label-cols="4">
								<b-form-input disabled type="text" v-model="c.hold_reason" />
							</b-form-group>
						</b-card>

						<b-row>
							<b-col cols="3">Allowed:</b-col>
							<b-col cols="2" class="text-right">{{ allowedVisits(c) }}</b-col>
                            <b-col cols="4"><span>(Rx:&nbsp;{{c.total_prescribed_visits }} Ins:&nbsp;{{ c.ins_available_visits }})</span></b-col>
						</b-row>
						<b-row>
							<b-col cols="3">Treated:</b-col>
							<b-col cols="2" class="text-right">{{ c.last_visit_app_count }}</b-col>
						</b-row>
						<b-row>
							<b-col cols="3">Scheduled:</b-col>
							<b-col cols="2" class="text-right">{{ c.scheduled_visit_count }}</b-col>
						</b-row>
						<b-row>
							<b-col cols="3" class="font-weight-bold">Remaining:</b-col>
							<b-col cols="2" class="text-right">{{ remainingVisits(c) }}</b-col>
						</b-row>
                        <hr/>

						<b-form-group label="Visit Forecast:" label-cols="4">
							<b-input name="total_forecast_visits" type="number" v-model="c.total_forecast_visits" />
						</b-form-group>
						<b-form-group v-if="c.lead" label="Dr Visit:" label-cols="4">
							<b-input name="future_dr_visit" type="date" :value="c.lead.future_dr_visit" />
						</b-form-group>
						<b-form-group label="Rx Visits:" label-cols="4">
							<b-input type="number" readonly  :value="c.total_prescribed_visits" class="align-items-right" />
						</b-form-group>
						<b-form-group label="Rx Freq:" label-cols="4">
							<b-input type="number" readonly  :value="c.prescribed_frequency" />
						</b-form-group>
					</b-card>
					<b-card v-else>
						No PatientIntake Found
					</b-card>
					<b-card v-if="c.lead">
						<b-card-title>Ops & Onboarding</b-card-title>
						<b-card v-if="!c.last_visit_at">
							<b-card-title>Onboarding</b-card-title>
							<b-form-group label="Eval Notes:" label-cols="4">
								<b-form-textarea disabled v-model="c.lead.eval_special_instructions"/>
							</b-form-group>
							<b-form-group disabled label="Please Collect: " label-cols="4">
									<b-form-checkbox v-if="c.lead.collect_forms_at_eval" v-model="c.lead.collect_forms_at_eval">Forms</b-form-checkbox>
									<b-form-checkbox v-if="c.lead.collect_cc_form_at_eval" v-model="c.lead.collect_cc_form_at_eval">CC Form</b-form-checkbox>
									<b-form-checkbox v-if="c.lead.collect_copies_of_ins_ca" v-model="c.lead.collect_copies_of_ins_ca">Ins Cards</b-form-checkbox>
									<b-form-checkbox v-if="!c.rx_received" :value="false" v-model="c.rx_received">Rx</b-form-checkbox>
								</b-form-checkbox-group>
							</b-form-group>
						</b-card>
						<!--{{c.lead}}-->
						<b-form-group label="Forms Type: " label-cols="4">
								<b-input type="text" readonly v-model="c.lead.forms_to_send" />
						</b-form-group>
						<b-form-group label="Forms Received: " label-cols="4">
								<b-form-checkbox name="forms_received" :value="true" :unchecked-value="false" v-model="c.forms_received"/>
						</b-form-group>
						<b-form-group label="Rx Received: " label-cols="4">
								<b-form-checkbox name="rx_received" :value="true" :unchecked-value="false" v-model="c.rx_received"/>
						</b-form-group>
						<b-card>
							<b-card-title>Communication w/ Ops</b-card-title>
							<b-form-group label="New Note to Ops" label-cols="4">
								<b-form-textarea name="new_therapist_note_to_ops" />
							</b-form-group>
							<b-form-group label="Last Note to Ops" label-cols="4">
								<b-form-textarea disabled v-model="c.lead.last_note_to_ops" />
							</b-form-group>
							<b-form-group label="Ops Note to Therapist" label-cols="4">
								<b-form-textarea disabled v-model="c.lead.last_note_to_therapist" />
							</b-form-group>
						</b-card>
					</b-card>
				</b-card-group>
			</b-card-text>
			<!-- DEV STUFF
			<b-card-group deck>
				<b-card><b-card-title> PATIENT </b-card-title> {{ c.patient }}</b-card>
				<b-card><b-card-title> TREAT THERAPIST </b-card-title> {{ c.treating_therapist }}</b-card>
				<b-card><b-card-title> PATIENTINTAKE </b-card-title> {{ c.lead }}</b-card>
				<b-card><b-card-title> DOCTOR </b-card-title> {{ c.doctor }}</b-card>
			</b-card-group>
			{{ c }}
			-->
		</b-collapse>
		</b-form>
	</b-card>
  </div>
</template>

<script>
var qs = require('qs');
import moment from 'moment-timezone'
export default {
  name: 'TherapistPortalV2',
  mounted() {
	  this.$root.getTherapists(true)
	},
	watch: {
		f_therapist: function(v) {
			this.$root.getCurrentCasesForTherapist(v);
		},
	},
	computed: {
		filtered_cases: function() {
			var patient_filtered = this.f_patient_name.length > 1 ? this.therapist_cases.filter(v=>(v.patient.last_name.toLowerCase() + v.patient.first_name.toLowerCase()).includes(this.f_patient_name.toLowerCase())) : this.therapist_cases
			var therapist_filtered = patient_filtered /*this.f_therapist > 0 ? patient_filtered.filter(c=> {
					var a = [c.treating_therapist.id]
					if (c.hasOwnProperty('eval_therapist')) {
						a.push(c.eval_therapist.id)
					}
					return a.find(v => v == this.f_therapist)
				}): patient_filtered */

			return therapist_filtered.sort((a,b)=>{
				if (this.sortBy == 'Next App') {
					if (a.next_visit_at === b.next_visit_at) return 0
					else if (a.next_visit_at === null) return -1
					else if (b.next_visit_at === null) return 1
					return moment(a.next_visit_at).valueOf() - moment(b.next_visit_at).valueOf()
				}
				return a.patient.last_name ? (a.patient.last_name+','+a.patient.first_name).localeCompare((b.patient.last_name+','+b.patient_first_name)) : -1
			})
		},
		cases: function() {
			return this.getDataForTherapist()
		},
		therapist_opts: function() { // Extracts from the Cases Provided
			return this.$root.therapists.map(t => {
				return {value: t.id, text: t.last_name.concat(', ', t.first_name)}
			}).sort((a,b) => a.text.localeCompare(b.text));

			/* Keeping this here for now
			return this.therapist_cases.map(c=> {
				var a =  [
					{value: c.treating_therapist.id, text: c.treating_therapist.therapist},
				]
				// TODO: Ensure the response always has this
				if (c.hasOwnProperty('eval_therapist') && typeof c.eval_therapist === "object" && c.eval_therapist.hasOwnProperty('id')) {
					a.push({value: c.eval_therapist.id, text: c.eval_therapist.therapist})
				}

				return a
			}).flat().filter((v,i,s)=> s.map(r=>r.value).indexOf(v.value) === i).sort( (a,b) => a.text.localeCompare(b.text))
			*/
		},
		therapist_cases: function() {
			return this.$root.active_cases_with_payers
		},
		payers: function() {
			return this.$root.all_payers
		},
		payer_opts: function() {
			return this.$root.payer_opts
		},
		doctor_opts: function() {
			return this.$root.doctor_opts
		},
		doctors: function() {
			return this.$root.all_doctors
		},
	},
	filters: {
		formatPhone(v) {
			var cleaned = ('' + v).replace(/\D/g, '')
			var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
			if (match) {
				return '(' + match[1] + ') ' + match[2] + '-' + match[3]
			}

			return null
		},

		formatDateTime(v) {
			return moment.tz(v, "Zulu").format("MM/DD/YYYY HH:mm A")
		},
		formatDate(v) {
			return moment.tz(v, "Zulu").format("MM/DD/YYYY")
		},
	},
  data: function () {
    return {
		f_patient_name: '',
		f_therapist: '',
		sortBy: 'Patient Name',
		updates: [],
		concerns: [],
		saving: false,
		new_note_to_ops: '',
    }
  },

  methods: {
	  validCase(c) {
		  const hasPatientIntake = c.hasOwnProperty('lead') && typeof c.lead == 'object' && c.lead.hasOwnProperty('id')
		  return hasPatientIntake
	  },
	  businessConcerns(c) {
		  const underLimit = this.remainingVisits(c) >= 0
		  const hasNextVisit = c.status == 'On Hold' || c.next_visit_at
		  return hasNextVisit && underLimit
	  },
	  allowedVisits(c) {
        return Math.min(parseInt(c.total_prescribed_visits), c.ins_available_visits);
      },
	  remainingVisits(c) {
        const maxAllowed = Math.min(parseInt(c.total_prescribed_visits), c.ins_available_visits);
        // return maxAllowed - (c.last_visit_app_count + c.scheduled_visit_count)
        return this.allowedVisits(c) - (c.last_visit_app_count + c.scheduled_visit_count)
      },
      bgVariant: function(c) {
        if (c.status == 'On Hold')
          return 'row-blue';
        else if ((c.scheduled_visit_count < 2 && c.last_visit_at && (c.last_visit_app_count + c.scheduled_visit_count) < c.total_forecast_visits) || (c.scheduled_visit_count == 0))
          return 'row-yellow';
        return 'light';
      },
	  getPatientGoogleMapLink(c) {
		  return 'https://maps.google.com/?q='+c.patient.address+','+c.patient.city+','+c.patient.state+' '+c.patient.zip;
	  },
	  getDoctorGoogleMapLink(c) {
		  return 'https://maps.google.com/?q='+c.doctor.address+','+c.doctor.city+','+c.doctor.state+' '+c.doctor.zip;
	  },
     selectedTherapist() {
       if (this.f_therapist.length == 0) { return "" }
       const t = this.therapist_opts.filter(e=>e.value == (this.f_therapist));
       return t[0].text
      },
	  handleSave(e) {
		this.saving = true
		e.preventDefault()
		//console.log(e)
		const idx = parseInt(e.target.id.replace('FORM__', ''))
		//const source = this.filtered_cases[idx]

		//console.log(e.target.elements.forms_received)
		const v = {
			id: e.target.elements.lead_id.value,
			total_visit_forecast: e.target.elements.total_forecast_visits.value,
			future_dr_visit: e.target.elements.future_dr_visit.value,
			new_therapist_note_to_ops: e.target.new_therapist_note_to_ops.value,
			forms_received: e.target.elements.forms_received.checked,
			rx_received: e.target.elements.rx_received.checked,
		}

		//v.id = 11 // For Testing
		this.$root.saveLead(v).then(r => {
				this.$bvToast.toast('Your changes have been saved', {
				title: 'Save Successful',
				autoHideDelay: 3000,
				toaster: 'b-toaster-bottom-center',
				variant: 'success',
			})

			this.saving = false

			this.$root.$emit('bv::toggle::collapse', 'COLLAPSE__'+idx)
		}).catch( e => {
			// console.log(e)
			this.$bvToast.toast(e, {
				title: 'Save Error',
				autoHideDelay: 3000,
				toaster: 'b-toaster-bottom-center',
				variant: 'danger',
			})

			this.saving = false
		})
	  },

  },
}
</script>
